import * as form from '../form';

export const militarySelective = (data = {}) => ({
  WasBornAfter: form.branch(data.WasBornAfter),
  HasRegistered: form.branch(data.HasRegistered),
  HasRegisteredNotApplicable: form.notapplicable(data.HasRegisteredNotApplicable),
  RegistrationNumber: form.text(data.RegistrationNumber),
  Explanation: form.textarea(data.Explanation),
  Comments: form.textarea(data.Comments),
  AnswerComments: form.textarea(data.AnswerComments),
  RegistrationNumberComments: form.textarea(data.RegistrationNumberComments),
  DNKComments: form.textarea(data.DNKComments),
  LegalExemptionComments: form.textarea(data.LegalExemptionComments),
});
